import React from 'react'

import { makeStyles } from '@material-ui/core/styles'

import Typography from '@material-ui/core/Typography'

import numberUtils from 'shared/src/utils/number'
import resourceInfo from 'shared/src/resource/info'
import resourcePrice from 'shared/src/resource/price'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
  },
  smallText: {
    fontSize: '0.8em',
    color: '#999'
  },
  boldText: {
    fontWeight: 'bold',
  },
}))

const PriceSummary  = ({
  currency,
  noAnnotation,
  resource, 
  bold,
  amount,
  unit,
  noPrice,
  noUnit,
}) => {
  const classes = useStyles()

  const getAnnotation = ({
    resource,
    price,
  }) => {
  
    if(noAnnotation) return null

    if(resourceInfo.isRateBased(resource)) {
      return (
        <Typography className={ classes.smallText }>
          { currency } { numberUtils.twoDp(price.base.price) } / { 
            resourceInfo.unitTitle({
              amount: price.base.amount,
              unit: price.base.unit || resource.meta.unit,
            })
          }
        </Typography>
      )
    }
    else if(resourceInfo.isTimeBased(resource)) {
      return (
        <Typography className={ classes.smallText }>
          { currency } { numberUtils.twoDp(price.base.price) } / Day
        </Typography>
      )
    }
  }

  const getUnitTitle = (price) => {
    if(noUnit || noPrice) return null

    const unitTitle = resourceInfo.unitTitle({
      amount: price.amount,
      unit: price.unit,
    })

    return (
      <React.Fragment>
        <span className={ classes.smallText }>/</span>  { unitTitle }
      </React.Fragment>
    )
  }

  if(resource.type == 'folder') return null

  const price = resourcePrice({
    resource, 
    amount,
    unit,
  })

  return (
    <div>
      <Typography
        className={ bold ? classes.boldText : '' }
      >
        { !noPrice && currency } { !noPrice && numberUtils.twoDp(price.price) } { getUnitTitle(price) }
      </Typography>
      {
        getAnnotation({
          resource,
          price,
        })
      }
    </div>
  )
}

export default PriceSummary

